import { useState } from 'react';
import PageLayout from '../../../components/feature/PageLayout';
import PageHero from '../../../components/feature/PageHero';
import AnnouncementBuilder, { BuilderData } from '../../../components/feature/AnnouncementBuilder';
import { submitLocalForm } from '../../../lib/localForms';

export default function MarriageFormPage() {
  const [formData, setFormData] = useState({
    bridegroomName: '',
    bridegroomFamilyName: '',
    bridegroomPlaceOfBirth: '',
    bridegroomDateOfBirth: '',
    bridegroomFatherName: '',
    bridegroomFatherFamilyName: '',
    bridegroomMotherName: '',
    bridegroomMotherFamilyName: '',
    bridegroomWitnessName: '',
    bridegroomWitnessFamilyName: '',
    bridegroomWitnessAddress: '',
    bridegroomWitnessEmail: '',
    bridegroomWitnessPhone: '',
    brideName: '',
    brideFamilyName: '',
    bridePlaceOfBirth: '',
    brideDateOfBirth: '',
    brideFatherName: '',
    brideFatherFamilyName: '',
    brideMotherName: '',
    brideMotherFamilyName: '',
    brideWitnessName: '',
    brideWitnessFamilyName: '',
    brideWitnessAddress: '',
    brideWitnessEmail: '',
    brideWitnessPhone: '',
    location: 'Saint Mina & Pope Cyril VI COC',
    priest: 'Father Anthony',
    priestOther: '',
    locationOther: '',
    posterOption: 'builder',
    eventDate: '',
    eventTime: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'success' | 'error' | null>(null);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [builderData, setBuilderData] = useState<BuilderData>({ photoDataUrl: '', customMessage: '', imagePosition: 'center', themeIndex: 0, hasPhoto: false });
  const [posterMode, setPosterMode] = useState<'builder' | 'upload'>('builder');
  const [customPosterFile, setCustomPosterFile] = useState<File | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.bridegroomName.trim()) newErrors.bridegroomName = 'Required';
    if (!formData.bridegroomFamilyName.trim()) newErrors.bridegroomFamilyName = 'Required';
    if (!formData.bridegroomPlaceOfBirth.trim()) newErrors.bridegroomPlaceOfBirth = 'Required';
    if (!formData.bridegroomDateOfBirth) newErrors.bridegroomDateOfBirth = 'Required';
    if (!formData.bridegroomFatherName.trim()) newErrors.bridegroomFatherName = 'Required';
    if (!formData.bridegroomFatherFamilyName.trim()) newErrors.bridegroomFatherFamilyName = 'Required';
    if (!formData.bridegroomMotherName.trim()) newErrors.bridegroomMotherName = 'Required';
    if (!formData.bridegroomMotherFamilyName.trim()) newErrors.bridegroomMotherFamilyName = 'Required';
    if (formData.bridegroomWitnessName.trim() || formData.bridegroomWitnessFamilyName.trim()) {
      if (!formData.bridegroomWitnessAddress.trim()) newErrors.bridegroomWitnessAddress = 'Required when witness is specified';
      if (!formData.bridegroomWitnessEmail.trim()) newErrors.bridegroomWitnessEmail = 'Required when witness is specified';
      if (!formData.bridegroomWitnessPhone.trim()) newErrors.bridegroomWitnessPhone = 'Required when witness is specified';
    }
    if (!formData.brideName.trim()) newErrors.brideName = 'Required';
    if (!formData.brideFamilyName.trim()) newErrors.brideFamilyName = 'Required';
    if (!formData.bridePlaceOfBirth.trim()) newErrors.bridePlaceOfBirth = 'Required';
    if (!formData.brideDateOfBirth) newErrors.brideDateOfBirth = 'Required';
    if (!formData.brideFatherName.trim()) newErrors.brideFatherName = 'Required';
    if (!formData.brideFatherFamilyName.trim()) newErrors.brideFatherFamilyName = 'Required';
    if (!formData.brideMotherName.trim()) newErrors.brideMotherName = 'Required';
    if (!formData.brideMotherFamilyName.trim()) newErrors.brideMotherFamilyName = 'Required';
    if (formData.brideWitnessName.trim() || formData.brideWitnessFamilyName.trim()) {
      if (!formData.brideWitnessAddress.trim()) newErrors.brideWitnessAddress = 'Required when witness is specified';
      if (!formData.brideWitnessEmail.trim()) newErrors.brideWitnessEmail = 'Required when witness is specified';
      if (!formData.brideWitnessPhone.trim()) newErrors.brideWitnessPhone = 'Required when witness is specified';
    }
    if (formData.priest === 'Other' && !formData.priestOther.trim()) {
      newErrors.priestOther = 'Please specify who will conduct the marriage';
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.bridegroomWitnessEmail && !emailRegex.test(formData.bridegroomWitnessEmail)) newErrors.bridegroomWitnessEmail = 'Invalid email format';
    if (formData.brideWitnessEmail && !emailRegex.test(formData.brideWitnessEmail)) newErrors.brideWitnessEmail = 'Invalid email format';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) { setSubmitStatus('error'); return; }
    setIsSubmitting(true);
    setSubmitStatus(null);
    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        if (key === 'priestOther') return;
        if (key === 'locationOther') return;
        if (key === 'priest') {
          formBody.append('priest', formData.priest === 'Other' ? formData.priestOther : formData.priest);
          return;
        }
        if (key === 'location') {
          formBody.append('location', formData.location === 'Other Location' && formData.locationOther ? formData.locationOther : formData.location);
          return;
        }
        formBody.append(key, value);
      });
      formBody.set('posterOption', posterMode);
      if (posterMode === 'upload') {
        formBody.append('customPoster', customPosterFile ? 'Uncollectable' : 'Not provided');
      } else {
        if (builderData.hasPhoto) formBody.append('announcementPhoto', 'Uncollectable');
        if (builderData.customMessage) formBody.append('announcementMessage', builderData.customMessage);
      }
      const response = await submitLocalForm('Marriage Form', formBody);
      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ bridegroomName: '', bridegroomFamilyName: '', bridegroomPlaceOfBirth: '', bridegroomDateOfBirth: '', bridegroomFatherName: '', bridegroomFatherFamilyName: '', bridegroomMotherName: '', bridegroomMotherFamilyName: '', bridegroomWitnessName: '', bridegroomWitnessFamilyName: '', bridegroomWitnessAddress: '', bridegroomWitnessEmail: '', bridegroomWitnessPhone: '', brideName: '', brideFamilyName: '', bridePlaceOfBirth: '', brideDateOfBirth: '', brideFatherName: '', brideFatherFamilyName: '', brideMotherName: '', brideMotherFamilyName: '', brideWitnessName: '', brideWitnessFamilyName: '', brideWitnessAddress: '', brideWitnessEmail: '', brideWitnessPhone: '', location: 'Saint Mina & Pope Cyril VI COC', priest: 'Father Anthony', priestOther: '', locationOther: '', posterOption: 'builder', eventDate: '', eventTime: '' });
        setBuilderData({ photoDataUrl: '', customMessage: '', imagePosition: 'center', themeIndex: 0, hasPhoto: false });
        setCustomPosterFile(null);
        setPosterMode('builder');
      } else { setSubmitStatus('error'); }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally { setIsSubmitting(false); }
  };

  return (
    <PageLayout>
      <PageHero title="Marriage Form" subtitle="Complete this form for marriage declaration document and poster" />
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="bg-burgundy-50 border-l-4 border-burgundy-700 p-6 mb-8 rounded-r-lg">
          <p className="text-gray-700 italic text-base leading-relaxed">"Therefore what God has joined together, let no one separate."</p>
          <p className="text-gray-600 text-sm mt-2">— Mark 10:9</p>
        </div>
        <div className="bg-gold-50 border border-gold-200 rounded-lg p-6 mb-8">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-gold-600 text-xl mt-0.5"></i>
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">Form Purpose</h3>
              <p className="text-gray-700 text-sm leading-relaxed">This information will be used to complete the marriage declaration document and create the marriage poster. Please ensure all details are accurate and complete.</p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-10" id="marriage-form" data-local-form>
          {/* Bridegroom Information */}
          <div className="bg-white rounded-xl border border-gray-200 p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-3 border-b-2 border-burgundy-700">Bridegroom Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                ['bridegroomName', 'Bridegroom\'s Name', 'First name'],
                ['bridegroomFamilyName', 'Bridegroom\'s Family Name', 'Last name'],
                ['bridegroomPlaceOfBirth', 'Place of Birth', 'City, town, village, province, or country'],
                ['bridegroomFatherName', 'Father\'s Name', 'Father\'s first name'],
                ['bridegroomFatherFamilyName', 'Father\'s Family Name', 'Father\'s last name'],
                ['bridegroomMotherName', 'Mother\'s Name', 'Mother\'s first name'],
                ['bridegroomMotherFamilyName', 'Mother\'s Family Name', 'Mother\'s last name'],
              ].map(([name, label, placeholder]) => (
                <div key={name} className={name === 'bridegroomPlaceOfBirth' ? 'md:col-span-2' : ''}>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{label} <span className="text-red-500">*</span></label>
                  <input type="text" name={name} value={formData[name as keyof typeof formData]} onChange={handleChange} placeholder={placeholder} className={`w-full px-4 py-2.5 border ${errors[name] ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`} />
                  {errors[name] && <p className="text-red-500 text-xs mt-1">{errors[name]}</p>}
                </div>
              ))}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Date of Birth <span className="text-red-500">*</span></label>
                <input type="date" name="bridegroomDateOfBirth" value={formData.bridegroomDateOfBirth} onChange={handleChange} className={`w-full px-4 py-2.5 border ${errors.bridegroomDateOfBirth ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`} />
                {errors.bridegroomDateOfBirth && <p className="text-red-500 text-xs mt-1">{errors.bridegroomDateOfBirth}</p>}
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Witness Information (if not one of the parents)</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div><label className="block text-sm font-medium text-gray-700 mb-2">Witness's Name</label><input type="text" name="bridegroomWitnessName" value={formData.bridegroomWitnessName} onChange={handleChange} placeholder="First name" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm" /></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-2">Witness's Family Name</label><input type="text" name="bridegroomWitnessFamilyName" value={formData.bridegroomWitnessFamilyName} onChange={handleChange} placeholder="Last name" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm" /></div>
                <div className="md:col-span-2"><label className="block text-sm font-medium text-gray-700 mb-2">Address of Witness/Parents</label><input type="text" name="bridegroomWitnessAddress" value={formData.bridegroomWitnessAddress} onChange={handleChange} placeholder="Full address" className={`w-full px-4 py-2.5 border ${errors.bridegroomWitnessAddress ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`} />{errors.bridegroomWitnessAddress && <p className="text-red-500 text-xs mt-1">{errors.bridegroomWitnessAddress}</p>}</div>
                <div><label className="block text-sm font-medium text-gray-700 mb-2">Email of Witness/Parents</label><input type="email" name="bridegroomWitnessEmail" value={formData.bridegroomWitnessEmail} onChange={handleChange} placeholder="email@example.com" className={`w-full px-4 py-2.5 border ${errors.bridegroomWitnessEmail ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`} />{errors.bridegroomWitnessEmail && <p className="text-red-500 text-xs mt-1">{errors.bridegroomWitnessEmail}</p>}</div>
                <div><label className="block text-sm font-medium text-gray-700 mb-2">Phone Number of Witness/Parents</label><input type="tel" name="bridegroomWitnessPhone" value={formData.bridegroomWitnessPhone} onChange={handleChange} placeholder="(123) 456-7890" className={`w-full px-4 py-2.5 border ${errors.bridegroomWitnessPhone ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`} />{errors.bridegroomWitnessPhone && <p className="text-red-500 text-xs mt-1">{errors.bridegroomWitnessPhone}</p>}</div>
              </div>
            </div>
          </div>

          {/* Bride Information */}
          <div className="bg-white rounded-xl border border-gray-200 p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-3 border-b-2 border-burgundy-700">Bride Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                ['brideName', 'Bride\'s Name', 'First name'],
                ['brideFamilyName', 'Bride\'s Family Name', 'Last name'],
                ['bridePlaceOfBirth', 'Place of Birth', 'City, town, village, province, or country'],
                ['brideFatherName', 'Father\'s Name', 'Father\'s first name'],
                ['brideFatherFamilyName', 'Father\'s Family Name', 'Father\'s last name'],
                ['brideMotherName', 'Mother\'s Name', 'Mother\'s first name'],
                ['brideMotherFamilyName', 'Mother\'s Family Name', 'Mother\'s last name'],
              ].map(([name, label, placeholder]) => (
                <div key={name} className={name === 'bridePlaceOfBirth' ? 'md:col-span-2' : ''}>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{label} <span className="text-red-500">*</span></label>
                  <input type="text" name={name} value={formData[name as keyof typeof formData]} onChange={handleChange} placeholder={placeholder} className={`w-full px-4 py-2.5 border ${errors[name] ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`} />
                  {errors[name] && <p className="text-red-500 text-xs mt-1">{errors[name]}</p>}
                </div>
              ))}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Date of Birth <span className="text-red-500">*</span></label>
                <input type="date" name="brideDateOfBirth" value={formData.brideDateOfBirth} onChange={handleChange} className={`w-full px-4 py-2.5 border ${errors.brideDateOfBirth ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`} />
                {errors.brideDateOfBirth && <p className="text-red-500 text-xs mt-1">{errors.brideDateOfBirth}</p>}
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Witness Information (if not one of the parents)</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div><label className="block text-sm font-medium text-gray-700 mb-2">Witness's Name</label><input type="text" name="brideWitnessName" value={formData.brideWitnessName} onChange={handleChange} placeholder="First name" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm" /></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-2">Witness's Family Name</label><input type="text" name="brideWitnessFamilyName" value={formData.brideWitnessFamilyName} onChange={handleChange} placeholder="Last name" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm" /></div>
                <div className="md:col-span-2"><label className="block text-sm font-medium text-gray-700 mb-2">Address of Witness/Parents</label><input type="text" name="brideWitnessAddress" value={formData.brideWitnessAddress} onChange={handleChange} placeholder="Full address" className={`w-full px-4 py-2.5 border ${errors.brideWitnessAddress ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`} />{errors.brideWitnessAddress && <p className="text-red-500 text-xs mt-1">{errors.brideWitnessAddress}</p>}</div>
                <div><label className="block text-sm font-medium text-gray-700 mb-2">Email of Witness/Parents</label><input type="email" name="brideWitnessEmail" value={formData.brideWitnessEmail} onChange={handleChange} placeholder="email@example.com" className={`w-full px-4 py-2.5 border ${errors.brideWitnessEmail ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`} />{errors.brideWitnessEmail && <p className="text-red-500 text-xs mt-1">{errors.brideWitnessEmail}</p>}</div>
                <div><label className="block text-sm font-medium text-gray-700 mb-2">Phone Number of Witness/Parents</label><input type="tel" name="brideWitnessPhone" value={formData.brideWitnessPhone} onChange={handleChange} placeholder="(123) 456-7890" className={`w-full px-4 py-2.5 border ${errors.brideWitnessPhone ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`} />{errors.brideWitnessPhone && <p className="text-red-500 text-xs mt-1">{errors.brideWitnessPhone}</p>}</div>
              </div>
            </div>
          </div>

          {/* Church Event Information */}
          <div className="bg-white rounded-xl border border-gray-200 p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-3 border-b-2 border-burgundy-700">Church Event Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Location <span className="text-red-500">*</span></label>
                <select name="location" value={formData.location} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm cursor-pointer">
                  <option value="Saint Mina & Pope Cyril VI COC">Saint Mina &amp; Pope Cyril VI COC</option>
                  <option value="Other Location">Other Location</option>
                </select>
                {formData.location === 'Other Location' && (
                  <input
                    type="text"
                    name="locationOther"
                    value={formData.locationOther}
                    onChange={handleChange}
                    placeholder="Please specify the location"
                    className="mt-3 w-full px-4 py-2.5 border border-gold-400 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm"
                  />
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Marriage Conducted By <span className="text-red-500">*</span></label>
                <select name="priest" value={formData.priest} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm cursor-pointer">
                  <option value="Father Anthony">Father Anthony</option>
                  <option value="Other">Other</option>
                </select>
                {formData.priest === 'Other' && (
                  <input
                    type="text"
                    name="priestOther"
                    value={formData.priestOther}
                    onChange={handleChange}
                    placeholder="Please specify who will conduct the marriage"
                    className={`mt-3 w-full px-4 py-2.5 border ${errors.priestOther ? 'border-red-500' : 'border-gold-400'} rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm`}
                  />
                )}
                {errors.priestOther && <p className="text-red-500 text-xs mt-1">{errors.priestOther}</p>}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Preferred Date <span className="text-gray-400 font-normal">(subject to approval)</span></label>
                <input
                  type="date"
                  name="eventDate"
                  value={formData.eventDate}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Preferred Time <span className="text-gray-400 font-normal">(subject to approval)</span></label>
                <input
                  type="time"
                  name="eventTime"
                  value={formData.eventTime}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-sm"
                />
              </div>
            </div>
            <div className="mt-4 bg-burgundy-50 border border-burgundy-200 rounded-lg p-4">
              <div className="flex items-start gap-2">
                <i className="ri-information-line text-burgundy-700 text-lg mt-0.5"></i>
                <p className="text-sm text-burgundy-800"><strong>Please note:</strong> Nothing is confirmed until Father Anthony has approved the requested date and time, unless it has already been confirmed beforehand. You will be contacted to finalize your marriage ceremony scheduling.</p>
              </div>
            </div>
          </div>

          {/* Announcement Poster */}
          <div className="bg-white rounded-xl border border-gray-200 p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-2 flex items-center"><i className="ri-image-line text-gold-600 mr-3"></i>Announcement Poster</h2>
            <p className="text-sm text-gray-500 mb-6">Choose how you'd like to create your wedding announcement.</p>
            <div className="flex gap-4 mb-8">
              <button type="button" onClick={() => setPosterMode('builder')} className={`flex-1 flex items-center justify-center gap-2 px-5 py-4 rounded-lg border-2 transition-all cursor-pointer whitespace-nowrap ${posterMode === 'builder' ? 'border-burgundy-700 bg-burgundy-50 text-burgundy-700 font-semibold' : 'border-gray-200 text-gray-600 hover:border-gray-300'}`}>
                <i className="ri-magic-line text-lg"></i>
                <span>Use Announcement Builder</span>
                {posterMode === 'builder' && <i className="ri-check-line text-burgundy-700 ml-1"></i>}
              </button>
              <button type="button" onClick={() => setPosterMode('upload')} className={`flex-1 flex items-center justify-center gap-2 px-5 py-4 rounded-lg border-2 transition-all cursor-pointer whitespace-nowrap ${posterMode === 'upload' ? 'border-burgundy-700 bg-burgundy-50 text-burgundy-700 font-semibold' : 'border-gray-200 text-gray-600 hover:border-gray-300'}`}>
                <i className="ri-upload-cloud-line text-lg"></i>
                <span>Upload My Own Poster</span>
                {posterMode === 'upload' && <i className="ri-check-line text-burgundy-700 ml-1"></i>}
              </button>
            </div>
            {posterMode === 'upload' && (
              <div>
                <p className="text-sm text-gray-600 mb-4">Upload your own custom-designed wedding poster. Accepted formats: JPG, PNG, PDF.</p>
                <label className="flex flex-col items-center justify-center w-full h-48 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-gold-500 hover:bg-gold-50 transition-colors">
                  {customPosterFile ? (
                    <div className="flex flex-col items-center gap-2">
                      <i className="ri-file-check-line text-4xl text-gold-600"></i>
                      <span className="text-sm font-medium text-burgundy-700">{customPosterFile.name}</span>
                      <span className="text-xs text-gray-500">Click to replace</span>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center gap-2 text-gray-500">
                      <i className="ri-upload-cloud-2-line text-4xl"></i>
                      <span className="text-sm font-medium">Click to upload your poster</span>
                      <span className="text-xs">JPG, PNG, PDF up to 10MB</span>
                    </div>
                  )}
                  <input type="file" accept=".jpg,.jpeg,.png,.pdf" className="hidden" onChange={(e) => setCustomPosterFile(e.target.files?.[0] ?? null)} />
                </label>
              </div>
            )}
          </div>

          {/* Announcement Builder (builder mode only) */}
          {posterMode === 'builder' && (
            <AnnouncementBuilder
              type="wedding"
              name1={formData.bridegroomName}
              familyName1={formData.bridegroomFamilyName}
              name2={formData.brideName}
              familyName2={formData.brideFamilyName}
              eventLocation={formData.location}
              onChange={setBuilderData}
            />
          )}

          {/* Submit */}
          <div className="flex flex-col items-center gap-4">
            <button type="submit" disabled={isSubmitting} className="bg-burgundy-700 hover:bg-burgundy-800 text-white font-semibold px-8 py-3 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer">
              {isSubmitting ? 'Submitting...' : 'Submit Marriage Form'}
            </button>
            {submitStatus === 'success' && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 w-full">
                <div className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-line text-green-600 text-2xl"></i>
                  <div><p className="font-semibold text-green-900">Form Submitted Successfully!</p><p className="text-sm text-green-700 mt-1">Thank you for submitting your marriage form. We will contact you shortly to schedule your ceremony.</p></div>
                </div>
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 w-full">
                <div className="flex items-center gap-3">
                  <i className="ri-error-warning-line text-red-600 text-2xl"></i>
                  <div><p className="font-semibold text-red-900">Submission Failed</p><p className="text-sm text-red-700 mt-1">Please check all required fields and try again. If the problem persists, contact the church office.</p></div>
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    </PageLayout>
  );
}
